import { useRef } from 'react';

import type { AsyncDataReloaderT } from '@dr.pogodin/react-global-state';
import { time } from '@dr.pogodin/react-utils';

import type { SessionT } from 'utils';
import { useAsyncData } from 'utils/global-state';

type SetT = (value: SessionT) => void;

type HeapT = {
  set: SetT;
};

export type UseSessionResT = {
  busy: boolean;
  data: SessionT | null;
  reload: AsyncDataReloaderT<SessionT>;
  set: SetT;
};

export function useSession(): UseSessionResT {
  const e = useAsyncData('session', () => null, {
    maxage: time.YEAR_MS,
  });

  const { current: heap } = useRef<HeapT>({
    // TODO: This is temporary, to have set() as a stable function,
    // later it will be available directly from the "react-global-state" lib:
    // https://github.com/birdofpreyru/react-global-state/issues/115
    set: (value: SessionT) => {
      void e.reload(() => value);
    },
  });

  // eslint-disable-next-line react-hooks/refs
  return {
    busy: e.loading,
    data: e.data,
    reload: e.reload,

    // eslint-disable-next-line react-hooks/refs
    set: heap.set,
  };
}
